/**
 * Custel theme controller — Sprint 28c hed_v3 sonrası **light-only**.
 *
 * BRANDBOOK §2.1: Dark mode token blokları silindi (`:root[data-theme='dark']`
 * + `@media (prefers-color-scheme: dark)`). Bu helper'lar geriye dönük API
 * uyumluluğu için no-op olarak korunur. Faz 4+'da manuel toggle geri açıldığında
 * dark token bloğu eklenip burası yeniden aktif edilir.
 */

export type ThemeMode = 'auto' | 'light' | 'dark';

/** Light-only — her zaman 'light' döner (kullanıcı tercih edemez). */
export function getStoredTheme(): ThemeMode {
  return 'light';
}

/**
 * No-op — light-only döneminde tema değiştirme devre dışı. Önceki
 * persist edilmiş `data-theme` attribute'unu temizler (legacy temizlik).
 */
export function applyTheme(_mode: ThemeMode): void {
  if (typeof document !== 'undefined') {
    document.documentElement.removeAttribute('data-theme');
  }
}

/** No-op stub — main.tsx import'unun çalışmasını sağlar. */
export function bootstrapTheme(): void {
  applyTheme('light');
}
